import http from "./_http";

export default async function getFormFiles({ onboardingId, documentId }) {
  const requiredFields = ['onboardingId', 'documentId'];
  requiredFields.forEach((field) => {
    // eslint-disable-next-line prefer-rest-params
    if (!arguments[0][field]) {
      throw new Error(`${field} is required`);
    }
  });

  return await http.get(
    `/onboarding/${onboardingId}/requested-documents/${documentId}/files`,
    {
      headers: {
        'Content-Type': 'application/pdf',
      },
      responseType: 'blob',
      data: {},
    }
  );
}
